<template>
    <playerList :type="'player'"></playerList>
</template>

<script>
    import playerList from "../components/newPlayerList";
    export default {
        name: "playersReport",
        components:{
            playerList
        }
    }
</script>

<style scoped>

</style>
